/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';

const DescriptionInput = styled.textarea`
	width: 100%;
	min-height: 165px;
	padding: 30px 25px 32px 14px;
	border: none;
	border-radius: 5px;
	outline: 0;
	resize: none;
	font-size: 20px;
	color: color: #686871;
`;

const Description = ({handleChange}) => (
    <DescriptionInput
        name="report-description"
        id="report-description"
        onChange={handleChange}
    >
    </DescriptionInput>
);

export default Description;


// WEBPACK FOOTER //
// ./src/components/task/working/report/description.js